import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'what_is_the_maximum_length_of_time_in_days_that_the_fac_conside'

export const dataPointDefinition = {
  retracedId: 'what_is_the_maximum_length_of_time_in_days_that_the_fac_conside',
  name: 'What is the maximum length of time (in days) that the facility considers workers as apprentices / interns / workers in training?',
  description:
    'The intent of this question is to understand what the maximum amount of TIME (in days) that a worker can be considered as apprentices/interns/workers in training. If the maximum amount of time differs between apprentices, interns, workers in training, then enter the highest number. \r\r\n\r\r\nFor example, if the facility limits internships to no more than 90 days in length, the response of "90" would be entered.',
  meta: {},
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'cl-5--3',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 4820,
  sectionId: '2.2.4.1',
  impactArea: 'Recruitment, Hiring & Termination Practices',
  impactAreaId: 'RECRUITMENT_HIRING_AND_TERMINATION_PRACTICES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
